"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BonusTag = void 0;
var BonusTag;
(function (BonusTag) {
    BonusTag["POSITION_HOME_BLOCK"] = "home-block";
    BonusTag["POSITION_PROMO_BANNER"] = "promo-banner";
    BonusTag["STANDARD_WITH_CODE"] = "standard_with_code";
    BonusTag["POSITION_HOME_BANNER"] = "home-banner";
    BonusTag["STANDARD"] = "standard";
    BonusTag["WELCOME_DEPOSIT_FIRST"] = "welcome-deposit-first";
    BonusTag["WELCOME_DEPOSIT_SECOND"] = "welcome-deposit-second";
    BonusTag["WELCOME_DEPOSIT_THIRD"] = "welcome-deposit-third";
    BonusTag["WELCOME_DEPOSIT_FOURTH"] = "welcome-deposit-fourth";
    BonusTag["WELCOME_DEPOSIT_FIRST_HIGHROLLER"] = "welcome-deposit-first-highroller";
    BonusTag["WELCOME_DEPOSIT_SECOND_HIGHROLLER"] = "welcome-deposit-second-highroller";
    BonusTag["WELCOME_DEPOSIT_THIRD_HIGHROLLER"] = "welcome-deposit-third-highroller";
    BonusTag["WELCOME_DEPOSIT_FOURTH_HIGHROLLER"] = "welcome-deposit-fourth-highroller";
    BonusTag["WELCOME_DEPOSIT_FIRST_VIP"] = "welcome-deposit-first-vip";
    BonusTag["WELCOME_DEPOSIT_SECOND_VIP"] = "welcome-deposit-second-vip";
    BonusTag["WELCOME_DEPOSIT_THIRD_VIP"] = "welcome-deposit-third-vip";
    BonusTag["WELCOME_DEPOSIT_FOURTH_VIP"] = "welcome-deposit-fourth-vip";
    BonusTag["DEFAULT"] = "default";
    BonusTag["SPECIAL_OFFER"] = "special-offer";
    BonusTag["NOT_FRONT"] = "not-front";
    BonusTag["EMAIL_NOT_CONFIRMED_VISIBLE"] = "email-not-confirmed-visible";
})(BonusTag = exports.BonusTag || (exports.BonusTag = {}));
